import React from 'react'

export const Footer = () => {
  return (
    <footer className="app-footer">
      <p>Built as a Notion-inspired todo workspace · MyTodosList.com</p>
      <p>Copyright &copy; MyTodosList.com</p>
    </footer>
  )
}
